import { useTranslation } from 'react-i18next';

export default function PeopleSearch() {
  const { t } = useTranslation();

  return (
    <div className="surface-body">
      <h1>{t('peopleSearch.title')}</h1>
      <div className="note" role="note" aria-live="polite">
        <h2>{t('peopleSearch.introTitle')}</h2>
        <p style={{ margin: 0 }}>{t('peopleSearch.introBody')}</p>
      </div>

      <section style={{ marginTop: 10 }}>
        <h2>{t('peopleSearch.friendlevel.title')}</h2>
        <p>{t('peopleSearch.friendlevel.body')}</p>
      </section>

      <section style={{ marginTop: 10 }}>
        <h2>{t('peopleSearch.giftable.title')}</h2>
        <p>{t('peopleSearch.giftable.body')}</p>
      </section>

      <section style={{ marginTop: 10 }}>
        <h2>{t('peopleSearch.lucky.title')}</h2>
        <p>{t('peopleSearch.lucky.body')}</p>
      </section>

      <section style={{ marginTop: 10 }}>
        <h2>{t('peopleSearch.interactable.title')}</h2>
        <p>{t('peopleSearch.interactable.body')}</p>
      </section>
    </div>
  );
}
